export default __webpack_public_path__ + "static/590-ecfd0cb1bd0eca5c88445f57fed303cc.gif";